import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unloading1",
  "use": "icon-unloading1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-unloading1\"><path d=\"M301.525333 85.333333v24.661334l613.034667 367.786666-86.144 0.512-526.506667-316.032-0.384-20.053333v337.237333a33.152 33.152 0 0 1 4.224-0.256H938.666667v190.592H305.749333l-4.224-0.298666v19.712H938.666667v148.736l-637.141334-0.128V938.666667H128V85.333333h173.525333z m527.616 647.466667l-36.138666 61.269333 102.656 0.042667v-61.269333h-66.517334z m-439.253333 0l-88.362667 0.042667v61.269333H353.706667l36.181333-61.312z m98.986667 0h-55.552l-36.138667 61.269333h55.509333l36.181334-61.269333z m98.986666 0h-55.594666l-36.181334 61.269333h55.594667l36.138667-61.269333z m98.944 0h-55.552l-36.181333 61.269333h55.552l36.181333-61.269333z m98.986667 0h-55.594667l-36.138666 61.269333h55.552l36.181333-61.269333z\" p-id=\"8340\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/unloading1.svg
// module id = aNSg
// module chunks = 215